export default {
    // apiUrl: 'https://localhost:44335/api',
    apiUrl: 'https://api.starlinebus-egypt.com',
    apiDebugMessages: false
}